import { EMPLOYEE_RESOURCE_CODES_API } from 'config/constants';

export const EMPLOYEE_BASE_URL = 'employee/';

export const EMPLOYEE_V1_BASE_URL = '/v1.1/employee/';

export const EMPLOYEE_ENDPOINTS = {
  LIST_EMPLOYEES: `${EMPLOYEE_V1_BASE_URL}`,
  GET_ALL_EMPLOYMENT_TYPES: `v1.1/employment_type/?per_page=5000`,
  EMPLOYEE_RESOURCE_CODES: EMPLOYEE_RESOURCE_CODES_API,
  GET_ALL_PAY_CATEGORIES: `v1.1/pay_category/?per_page=5000`,
  GET_EMPLOYEE: (id: string) => `${EMPLOYEE_BASE_URL}${id}/`,
  DELETE_EMPLOYEE: (id: string) => `${EMPLOYEE_BASE_URL}${id}/`,
  RESTORE_EMPLOYEE: (id: string) =>
    `${EMPLOYEE_BASE_URL}restore_employee/?employee_ids=${id}`,
  GET_ALL_EQUIPMENT_SUPPLIER: '/v1.1/equipment_supplier/',
  CREATE_EMPLOYEE: EMPLOYEE_BASE_URL,
  EDIT_EMPLOYEE: (id: string) => `${EMPLOYEE_BASE_URL}${id}/`,
  BULK_ARCHIEVE_EMPLOYEE: `${EMPLOYEE_V1_BASE_URL}bulk_archive/`,
  BULK_DELETE_EMPLOYEE: `${EMPLOYEE_V1_BASE_URL}bulk_delete/`,
  BULK_RESTORE_EMPLOYEE: `${EMPLOYEE_V1_BASE_URL}bulk_restore/`,
  RESET_PIN: `${EMPLOYEE_BASE_URL}send_pin_reset_link/`,
  GET_ALL_ALLOWANCE: `v1.1/allowance/`,
  REJECT_EMAIL: (id: string) =>
    `v1.1/email/reject_email_change_employee/?id=${id}`,
  REJECT_PHONE: (id: string) =>
    `v1.1/phone_number/reject_phone_change_employee/?id=${id}`,
  EXPORT_EMPLOYEE_EXCEL: `${EMPLOYEE_BASE_URL}export_employee/`,

  // this api end point will be changed once backend is ready
  GET_ALL_PROJECTS: `v1.1/daywork_dockets/dropdown/projects/?source=employee`,
  GET_RESOURCE_CODES: `/resource_code_list/employee_rate_sheet/`,
  EMPLOYEE_SETTING: 'v1.1/employee-setting/',
  GET_EMPLOYEE_DROPDOWN: 'v1.1/employee/dropdown/', // TODO: UPDATE THIS ENDPOINT
};

export const EMPLOYEE_TYPE_ENDPOINTS = {
  CREATE_EMPLOYMENT_TYPE: 'v1.1/employment_type/',
  EDIT_EMPLOYMENT_TYPE: (id: string) => `v1.1/employment_type/${id}/`,
};
